<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="page__inner">
          <p class="page__counter">04</p>
          <h1 class="subtitle subtitle_red page__subtitle">Антикризисное сопровождение, решение сложных коммуникационных кейсов</h1>
        </div>
      </div>
    </div>

    <anticrisis-background />

    <page-footer
      :prev="{ name: 'ecosystem' }"
      :next="{ name: 'design' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import AnticrisisBackground from '@/components/servicesSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'anticrisis',
  mixins: [RouteMixin],
  components: {
    AnticrisisBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.anticrisis-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__counter', 0.3, { y: '-20px', opacity: 0 }))
      .add(TweenMax.from('.page__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__subtitle', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__counter', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.anticrisis-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
